export var engagementDashboardMapper = function (data) {
    var totalData = [];
    var totalDataRecord = {
        totalOfTotalMeetings: 0,
        totalOfTotalVirtual: 0,
        totalOfTotalCalling: 0,
    };
    totalData.push(totalDataRecord);
    var engagementEntity = {
        totalOfData: [],
        data: [],
    };
    if (data && data.length > 0) {
        var engagementDashboards_1 = [], bucketList_1 = [];
        data.map(function (record) {
            if (!bucketList_1.includes(record.bucket)) {
                bucketList_1.push(record.bucket);
                var engagementRecord = {
                    type: record.bucket,
                    meeting: 0,
                    virtual: 0,
                    calling: 0,
                    data: [],
                };
                engagementDashboards_1.push(engagementRecord);
            }
        });
        engagementDashboards_1 = engagementDashboards_1.map(function (engagementRecord) {
            var productList = [];
            var subBucketList = [];
            data
                .filter(function (item) { return item.bucket === engagementRecord.type; })
                .map(function (record) {
                if (!productList.includes(record.product)) {
                    productList.push(record.product);
                    var subBucketRecord = {
                        type: record.product,
                        productId: record.productId,
                        meeting: 0,
                        virtual: 0,
                        calling: 0,
                        data: [],
                    };
                    subBucketList.push(subBucketRecord);
                }
                return record;
            });
            subBucketList = subBucketList.map(function (subBucketListRecord) {
                data
                    .filter(function (item) {
                    return item.bucket === engagementRecord.type &&
                        item.product === subBucketListRecord.type;
                })
                    .map(function (record) {
                    var engagementCategoryRecord = {
                        type: record.category,
                        meeting: record.meeting,
                        virtual: record.virtual,
                        calling: record.calling,
                        category: record.category,
                        categoryId: record.categoryId,
                    };
                    subBucketListRecord.meeting += record.meeting;
                    subBucketListRecord.virtual += record.virtual;
                    subBucketListRecord.calling += record.calling;
                    engagementRecord.meeting += record.meeting;
                    engagementRecord.virtual += record.virtual;
                    engagementRecord.calling += record.calling;
                    if (record.calling !== 0 ||
                        record.meeting !== 0 ||
                        record.virtual !== 0) {
                        subBucketListRecord.data.push(engagementCategoryRecord);
                    }
                    return record;
                });
                return subBucketListRecord;
            });
            engagementRecord.data = subBucketList;
            totalDataRecord.totalOfTotalCalling += engagementRecord.calling;
            totalDataRecord.totalOfTotalMeetings += engagementRecord.meeting;
            totalDataRecord.totalOfTotalVirtual += engagementRecord.virtual;
            return engagementRecord;
        });
        engagementEntity.data = engagementDashboards_1;
    }
    engagementEntity.totalOfData.push(totalDataRecord.totalOfTotalMeetings);
    engagementEntity.totalOfData.push(totalDataRecord.totalOfTotalVirtual);
    engagementEntity.totalOfData.push(totalDataRecord.totalOfTotalCalling);
    return engagementEntity;
};
